module.exports = __webpack_public_path__ + "static/media/ForAfrika.868b3f68.svg";